import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';

const NavContext = createContext({ navCollapsed: false, toggleNav: () => {} });

export function NavProvider({ children }) {
    const [navCollapsed, setNavCollapsed] = useState(() => {
        return localStorage.getItem('navCollapsed') === 'true';
    });

    useEffect(() => {
        localStorage.setItem('navCollapsed', navCollapsed);
    }, [navCollapsed]);

    const toggleNav = useCallback(() => setNavCollapsed(prev => !prev), []);

    return (
        <NavContext.Provider value={{ navCollapsed, toggleNav }}>
            {children}
        </NavContext.Provider>
    );
}

export function useNavState() {
    return useContext(NavContext);
}
